import { replaceString } from "@/data/util/String";

import { trans } from "@/app/localization/Trans";
import { BasePopover } from "@/app/popover/BasePopover";

export class MinimumAgePopover extends BasePopover {
    constructor(age: number, confirmHandler: { () }) {
        super(undefined, false);

        this.$element.addClass("minage");

        this.$body.append("<h1>" + trans.minimumAgePopover.title + "</h1>");
        this.$body.append("<p>" + replaceString(trans.minimumAgePopover.text, age + "") + "</p>");

        const btns = $('<div class="btns" />').appendTo(this.$body);
        let split = $('<div class="split" />').appendTo(btns);
        $('<button class="btn cancel">' + trans.minimumAgePopover.cancel + "</button>")
            .appendTo(split)
            .click(() => {
                this.hide();
            });

        split = $('<div class="split" />').appendTo(btns);
        $('<button class="btn">' + trans.minimumAgePopover.confirm + "</button>")
            .appendTo(split)
            .click(() => {
                confirmHandler();
                this.hide();
            });
    }

    protected onShow() {}

    protected onHide() {
        this.destroy();
    }

    protected onDestroy() {}
}
